import clsx from "clsx";
import { useRef } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { dates } from "@/lib/dates";
import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";

export const TimeAgoInTableCell = ({
  className,
  timestamp,
}: {
  className?: string;
  timestamp: string;
}) => {
  const hoverTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hoursAgo = dates.calculateHoursAgo(timestamp);
  const daysAgo = dates.calculateDaysAgo(timestamp);
  const timeAgo = dates.timeAgoForPipeline(timestamp);

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <p
            onMouseEnter={() => {
              hoverTimerRef.current = setTimeout(() => {
                mixpanelUtils.trackHover(
                  "Exact timestamp tooltip",
                  getScreenFromPathname(window.location.pathname),
                );
              }, 300);
            }}
            onMouseLeave={() => {
              if (hoverTimerRef.current) {
                clearTimeout(hoverTimerRef.current);
                hoverTimerRef.current = null;
              }
            }}
            className={clsx(
              className,
              hoursAgo < 24
                ? "text-green-700"
                : daysAgo < 3
                  ? "text-slate-700"
                  : daysAgo < 7
                    ? "text-yellow-600"
                    : "text-red-900",
            )}
          >
            {timeAgo}
          </p>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p className="text-xs">{dates.formatShortDateTime(timestamp)}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
